export default __webpack_public_path__ + "static/media/Militarydick.bffcdfed.PNG";